/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StripeWebhookService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param stripeSignature
     * @param mode
     * @returns any
     * @throws ApiError
     */
    public stripeWebhookControllerHandleWebhook(
        stripeSignature: string,
        mode: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/payment/stripe/webhook',
            headers: {
                'stripe-signature': stripeSignature,
            },
            query: {
                'mode': mode,
            },
        });
    }
}
